<template>
  <div class="flex flex-col w-full z-10" v-if="offer && itemsLoaded">
    <div class="w-full grid grid-cols-12 service-ex-row-headers">
      <div
        class="flex col-span-4 mobile:col-span-5 justify-start font-medium"
        :class="editMode ? 'mobile:hidden' : ''"
      >
        <h4>Kirjeldus</h4>
      </div>
      <div class="flex mobile:hidden justify-start">
        <h4>Kogus</h4>
      </div>
      <div class="flex  mobile:hidden justify-start">
        <h4>Ühik</h4>
      </div>
      <div class="flex mobile:hidden justify-start">
        <h4>Ühikuhind</h4>
      </div>
      <div class="flex mobile:hidden justify-start">
        <h4>Summa</h4>
      </div>
      <div class="flex mobile:hidden justify-start">
        <h4>KM%</h4>
      </div>
      <div class="flex mobile:hidden justify-start">
        <h4>KM</h4>
      </div>
      <div
        class="flex mobile:col-span-5justify-start "
        :class="editMode ? 'mobile:hidden' : 'col-span-1'"
      >
        <h4>Lõppsumma</h4>
      </div>
    </div>
    <div
      class="w-full h-1 rounded-full mt-2 duration-100 bg-offwhite mb-1"
    ></div>
    <div class="flex flex-col service-container z-10" id="service-container">
      <div class="flex flex-col" v-for="(item, index) in items" :key="item.id">
        <service-row
          :data="item"
          :is-white="true"
          :offer-status="offer.status"
          :edit-mode="editMode"
          :service-templates="serviceTemplates"
          @serviceUpdated="handleServiceUpdate"
          @removeService="handleRemoveService"
          v-if="!editMode"
        ></service-row>
        <new-service-row
          :service="item"
          @removeService="handleRemoveService"
          :service-templates="serviceTemplates"
          :index="index"
          :is-white="true"
          v-if="editMode"
          class="mb-1"
          :active-template-selector="activeTemplateSelector"
          @openTemplateSelector="changeActiveTemplateSelector"
        ></new-service-row>
        <div class="flex w-full h-1 bg-offwhite mb-1"></div>
      </div>
      <div>
        <div
          class="flex flex-col"
          v-for="item in newServices"
          :key="item.index"
        >
          <new-service-row
            :service="item"
            @removeService="removeService"
            :index="item.index"
            :service-templates="serviceTemplates"
            :active-template-selector="activeTemplateSelector"
            :is-white="true"
            v-if="editMode"
            class="mb-1"
            @openTemplateSelector="changeActiveTemplateSelector"
          ></new-service-row>
        </div>
      </div>
    </div>
    <div class="flex py-3 mt-3" v-if="editMode">
      <button @click="addService" class="alt-button-green">
        <span class="typcn typcn-plus icon"></span>
        <span class="label">Lisa rida</span>
      </button>
    </div>
    <div
      class="flex items-center pt-2"
      v-if="!this.$store.state.companyData.isClient"
    >
      <button
        class="alt-button-pending"
        @click="editMode = true"
        v-if="!editMode"
      >
        <span class="typcn typcn-edit icon"></span>
        <span class="label">Muuda</span>
      </button>
      <button
        v-if="editMode"
        @click="saveOfferItems"
        class="new-button-green mr-4"
      >
        <span class="typcn typcn-tick icon"></span>
        <span class="label">Salvesta</span>
      </button>
      <button
        @click="editMode = false"
        v-if="editMode"
        class="new-button-danger"
      >
        <span class="typcn typcn-times icon"></span>
        <span v-if="editMode" class="label">Tühista</span>
      </button>
    </div>
  </div>
</template>

<script>
import NewServiceRow from "../services/NewServiceRow";
import ServiceRow from "../services/ServiceRowExistingOffer";
import RequestHandler from "@/assets/mixins/RequestHandler";

export default {
  components: {
    NewServiceRow,
    ServiceRow
  },
  data() {
    return {
      editMode: false,
      newServices: [],
      items: [],
      itemsLoaded: false,
      serviceTemplates: [],
      activeTemplateSelector: null,
      serviceIndex: 0
    };
  },
  props: {
    draft: {
      type: Object,
      default: () => {
        return {};
      }
    },
    offer: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [RequestHandler],
  mounted() {
    if (!this.offer) {
      this.offer = this.$store.state.offerViewer.offerToDisplay;
    }
    this.getItems();
    this.loadTemplates();
  },

  methods: {
    loadTemplates() {
      if (!this.$store.state.companyData.isClient) {
        this.apiRequest(
          "projects/" +
            this.$store.state.companyData.activeCompany.uuid +
            "/templates/details/",
          "get",
          true
        ).then(res => {
          this.detailTemplates = res.data.filter(x => x.type === 1);
        });

        this.apiRequest(
          "projects/" +
            this.$store.state.companyData.activeCompany.uuid +
            "/templates/items/",
          "get",
          true
        ).then(res => {
          this.serviceTemplates = res.data;
        });
      }
    },
    getItems() {
      let url;
      if (!this.$store.state.companyData.isClient) {
        url =
          "notes/project/" + this.draft.uuid + "/" + this.offer.id + "/items/";
      } else {
        url =
          "projects/client/" +
          this.draft.uuid +
          "/offer/" +
          this.offer.id +
          "/items/";
      }

      this.apiRequest(url, "get", true).then(res => {
        this.items = res.data;
        this.itemsLoaded = true;
      });
    },
    genId(item) {
      const gennedId = Math.round(Math.random() * 100000);
      if (item) {
        this.items.find(x => x.id === item.id).index = gennedId;
      }
      return gennedId;
    },
    saveOfferItems() {
      this.$emit("serviceUpdated", {
        items: this.items,
        newServices: this.newServices
      });
      this.editMode = false;
      this.newServices = [];
    },
    addService() {
      let data = {
        index: this.serviceIndex,
        name: "",
        price: 0,
        amount: 0,
        unit: 1,
        vat: 20
      };
      this.serviceIndex += 1;
      this.newServices.push(data);
      setTimeout(function() {
        document
          .getElementById("service-container")
          .scroll({ left: 0, top: 999999, behavior: "smooth" });
      }, 100);
    },
    handleRemoveService(e) {
      if (this.items.find(item => item.id === e) !== undefined) {
        this.items.splice(
          this.items.findIndex(x => x.id === e),
          1
        );
      } else if (
        this.newServices.find(item => item.index === e) !== undefined
      ) {
        this.newServices.splice(
          this.newServices.findIndex(x => x.index === e),
          1
        );
      }
    },
    removeService(e) {
      this.newServices.splice(
        this.newServices.findIndex(item => item.index === e),
        1
      );
    },
    handleServiceUpdate(e) {
      let itemToChange = this.items.findIndex(item => item.id === e.id);
      this.items[itemToChange] = e;
    },
    changeActiveTemplateSelector(e) {
      this.activeTemplateSelector = e.id;
    }
  }
};
</script>
